export const helpers = {
	humanize: {
		paymentMethod: {
			anticipated: "Anticipated",
			bleedings: "Sangria",
			deliveryOnline: "Delivery Online",
			ame: "Ame",
			uber: "Uber",
			ifood: "Ifood",
			app: "App",
			cash: "Cash",
			automaticDebit: "Automatic Debit",
			boleto: "Bank slip",
			bankTransfer: "Bank transfer",
			promissory: "Promissory note",
			check: "Check",
			creditCard: "Credit card",
			zigPosCredit: "Zig post credit",
			zigCredit: "Zig Credit",
			debitCard: "Debit card",
			zigPosDebit: "Zig post debit",
			zigDebit: "Zig Debit",
			voucher: "Voucher",
			dashboard: "Dashboard",
			postEvent: "Post event",
			rappi: "Rappi",
			consumptionFromBar: "Early consummation",
			pix: "Pix",
			bonus: "Bonus",
			other: "Other",
			zigPosCreditInInstallments: "Installment",
			integratedFoodVoucher: "Food Voucher",
		},
	},
	string: {
		grams: "Grams",
		kilogram: "Kilograms",
		liter: "Liter",
		milliliter: "Mililiter",
		unit: "Unit",
		lowercase: {
			grams: "grams",
			kilogram: "kilogram",
			liter: "liter",
			milliliter: "milliliter",
			unit: "unit",
		},
	},
};
